import Licenses from "@/apiClient/Licenses"

const licenses = new Licenses()

const actions = {
  setPendingApproval: async ({ commit }, payload) => {
    const res = await licenses.getPendingAprovalLicenses(
      payload.idUser,
      payload.rowsPerPage,
      payload.page,
      payload.sortBy,
      payload.descending
    )
    if (res.status === 200) {
      const {
        data: {
          results: { data }
        }
      } = res
      const paginationData = res.data.pagination
      commit('SET_PEDING_APPROVAL', data)
      commit('SET_PEDING_APPROVAL_PAGINATION', paginationData)
    }
  },
  clearAllLicensesState: ({ commit }) => {
    commit('CLEAR_LICENSES_STATE')
  }
}

export default actions
